<template>
    <header class="header">
      <b-navbar toggleable variant="light" type="light">
        <b-navbar-toggle target="nav_text_collapse"></b-navbar-toggle>

        <b-navbar-brand><img width="32" src="@/assets/images/logo.png" alt=""> {{$appName}}</b-navbar-brand>

        <b-collapse is-nav id="nav_text_collapse">
            <b-navbar-nav class="ml-auto" v-if="$store.state.user">
                <b-nav-item>You are logged in as {{$store.state.user.firstName}}</b-nav-item>
                <b-nav-item-dropdown right class="no-padding">
                  <img class="img-rounded profile-img" :src="picture" slot="button-content">
                  <router-link class="dropdown-item" to="profile">Your Profile</router-link>
                  <router-link class="dropdown-item" to="#">Settings</router-link>
                  <router-link class="dropdown-item" to="#">Help</router-link>
                  <a v-on:click="logout" class="dropdown-item">Logout</a>
                </b-nav-item-dropdown>
            </b-navbar-nav>

        </b-collapse>

      </b-navbar>
   </header>
</template>

<script>

export default {
  name: 'Header',
  data: function () {
    return {
      foo: 'bar'
    }
  },
  methods: {
    logout: function () {
      this.$store.dispatch('logout').then(() => {
//        window.location.reload(false)
        this.$router.push('/login')
      })
    }
  },
  computed: {
    user: function () {
      return this.$store.state.user
    },
    picture: function () {
      return 'https://placehold.it/100x100'
    }
  }
}
</script>

<style>

.navbar{
  box-shadow: 0 0 20px rgb(214, 212, 216);
  border-bottom: 1px solid rgb(219, 226, 228);
}
.avatar {
  width: 40px;
  height: 40px;
  border-radius: 99em;
  border: 2px solid white;
  margin-left: 15px;
}

.dropdown-menu-right.show{
  position: relative;
}
.dropdown-menu-right.show:after {
  content: '';
  display: block;
  width: 20px;
  height: 20px;
  border-left: 1px solid orange;
  border-top: 1px solid orange;
  background: white;
  border-radius: 5px 0 0 0;
  position: absolute;
  top: -10px;
  right: 24px;
  transform: rotate(45deg);
  z-index: -1;
}

.profile-img{
    margin-right: 5px;
    float: left;
    width: 40px;
    height: 40px;
    margin: -10px 5px 0 0;
    border-radius: 99em;
    border: 2px solid white;
    box-shadow: 0 3px 4px rgba(0,0,0,0.3);
}
.dropdown-toggle::after{
  display: none;
}

.dropdown-item {
  outline: none !important;
}

</style>



// WEBPACK FOOTER //
// src/components/parts/Header.vue